// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"InfoSection_iconWrapper__t0UIl"};